import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/data';
import { WebSiteSchema, WebPageSchema, FAQPageSchema, OrganizationSchema } from '@/components/feature/SEOMeta';

const guestImages = [
  'https://readdy.ai/api/search-image?query=Attractive%20young%20Chinese%20woman%20portrait%20in%20tropical%20island%20setting%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20palm%20trees%20and%20ocean%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-1&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Elegant%20young%20Korean%20woman%20portrait%20on%20tropical%20beach%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20palm%20trees%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Handsome%20young%20Japanese%20man%20portrait%20on%20tropical%20beach%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20ocean%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-3&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Charming%20young%20Taiwanese%20woman%20portrait%20in%20tropical%20setting%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20palm%20trees%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-4&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Attractive%20young%20Indian%20man%20portrait%20on%20tropical%20beach%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20ocean%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-5&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Beautiful%20young%20Vietnamese%20woman%20portrait%20in%20tropical%20setting%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20palm%20trees%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-6&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Good%20looking%20young%20Chinese%20man%20portrait%20on%20tropical%20beach%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20ocean%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-7&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Stylish%20young%20Japanese%20woman%20portrait%20in%20tropical%20setting%2C%20warm%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20soft%20bokeh%20background%20with%20palm%20trees%2C%20clean%20minimal%20composition&width=600&height=800&seq=guest-8&orientation=portrait',
];

const episodeImages = [
  'https://readdy.ai/api/search-image?query=Romantic%20tropical%20beach%20scene%20with%20young%20diverse%20Asian%20couple%20meeting%20at%20sunset%2C%20cinematic%20lighting%2C%20reality%20TV%20show%20aesthetic%2C%20warm%20golden%20hour%20mood%2C%20palm%20trees%20silhouette%2C%20dreamy%20atmosphere&width=800&height=450&seq=ep-thumb-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Group%20of%20young%20diverse%20Asian%20people%20playing%20games%20on%20tropical%20beach%20at%20sunset%2C%20cinematic%20lighting%2C%20reality%20TV%20show%20aesthetic%2C%20fun%20and%20energetic%20vibe%2C%20warm%20golden%20hour&width=800&height=450&seq=ep-thumb-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Romantic%20couple%20pairing%20ceremony%20on%20tropical%20beach%20at%20sunset%2C%20cinematic%20lighting%2C%20reality%20TV%20show%20aesthetic%2C%20dramatic%20mood%2C%20warm%20golden%20hour%2C%20emotional%20atmosphere&width=800&height=450&seq=ep-thumb-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=New%20surprise%20guest%20arriving%20on%20tropical%20island%20beach%2C%20cinematic%20lighting%2C%20reality%20TV%20show%20aesthetic%2C%20dramatic%20entrance%2C%20warm%20golden%20hour%2C%20exciting%20atmosphere&width=800&height=450&seq=ep-thumb-4&orientation=landscape',
];

const articleImages = [
  'https://readdy.ai/api/search-image?query=Group%20of%20diverse%20attractive%20young%20Asian%20people%20posing%20on%20tropical%20beach%2C%20reality%20TV%20cast%20photo%2C%20cinematic%20lighting%2C%20warm%20vibrant%20colors%2C%20professional%20photography&width=800&height=500&seq=article-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Luxury%20private%20tropical%20island%20with%20beach%20villas%2C%20crystal%20clear%20turquoise%20water%2C%20palm%20trees%2C%20aerial%20view%2C%20cinematic%20lighting%2C%20paradise%20destination&width=800&height=500&seq=article-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Young%20Asian%20couple%20having%20deep%20conversation%20on%20beach%20at%20sunset%2C%20documentary%20style%2C%20cinematic%20lighting%2C%20emotional%20connection%2C%20warm%20intimate%20atmosphere&width=800&height=500&seq=article-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20filling%20out%20application%20form%20with%20tropical%20beach%20background%2C%20hopeful%20expression%2C%20cinematic%20lighting%2C%20warm%20inspirational%20mood&width=800&height=500&seq=article-4&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20young%20Asian%20couples%20from%20different%20countries%2C%20cultural%20diversity%20concept%2C%20tropical%20setting%2C%20cinematic%20lighting%2C%20warm%20harmonious%20atmosphere&width=800&height=500&seq=article-5&orientation=landscape',
  'https://readdy.ai/api/search-image?query=TV%20producer%20being%20interviewed%20with%20tropical%20island%20backdrop%2C%20professional%20setting%2C%20cinematic%20lighting%2C%20documentary%20style%2C%20warm%20authentic%20mood&width=800&height=500&seq=article-6&orientation=landscape',
];

const guests = [
  { id: 'guest-1', name: '林婉儿', nameEn: 'Waner Lin', age: 25, from: '中国上海', occupation: '时尚设计师', bio: '热爱生活，相信缘分天注定。期待在爱情岛找到那个能与我共度余生的灵魂伴侣。', img: guestImages[0] },
  { id: 'guest-2', name: '金泰妍', nameEn: 'Taeyeon Kim', age: 27, from: '韩国首尔', occupation: '音乐制作人', bio: '用音乐表达情感，用真心寻找爱情。我相信在这个美丽的岛屿上，会有奇迹发生。', img: guestImages[1] },
  { id: 'guest-3', name: '佐藤健太', nameEn: 'Kenta Sato', age: 28, from: '日本东京', occupation: '建筑设计师', bio: '设计过无数建筑，却从未设计过自己的爱情。希望在爱情岛亚洲找到那个让我心动的人。', img: guestImages[2] },
  { id: 'guest-4', name: '陈思雨', nameEn: 'Siyu Chen', age: 24, from: '中国台北', occupation: '插画师', bio: '用画笔描绘世界的美好，现在想用真心描绘一段真挚的爱情故事。', img: guestImages[3] },
  { id: 'guest-5', name: 'Raj Sharma', nameEn: 'Raj Sharma', age: 29, from: '印度孟买', occupation: '企业家', bio: '事业有成的我，现在最缺的就是一个能分享生活喜悦的伴侣。', img: guestImages[4] },
  { id: 'guest-6', name: 'Nguyen Mai', nameEn: 'Mai Nguyen', age: 26, from: '越南胡志明市', occupation: '舞蹈老师', bio: '舞蹈教会我用身体表达爱，现在我准备好用真心去感受爱了。', img: guestImages[5] },
  { id: 'guest-7', name: '李明浩', nameEn: 'Minghao Li', age: 30, from: '中国北京', occupation: '律师', bio: '在法庭上据理力争，在爱情面前我愿放下所有防备。', img: guestImages[6] },
  { id: 'guest-8', name: 'Arisa Tanaka', nameEn: 'Arisa Tanaka', age: 23, from: '日本大阪', occupation: '模特', bio: '走在聚光灯下的我，最渴望的是一份平凡而真挚的爱情。', img: guestImages[7] },
];

const episodes = [
  { id: 'ep-1', title: '第一集：初见·心跳加速', season: '第一季', epNum: 1, duration: '68分钟', date: '2026-07-15', desc: '八位单身男女首次登上爱情岛，初次见面的紧张与期待交织。谁会成为第一对擦出火花的组合？', img: episodeImages[0] },
  { id: 'ep-2', title: '第二集：破冰·真心话大冒险', season: '第一季', epNum: 2, duration: '72分钟', date: '2026-07-22', desc: '嘉宾们通过真心话大冒险游戏加深了解，一场意外的告白让整个岛屿都沸腾了。', img: episodeImages[1] },
  { id: 'ep-3', title: '第三集：选择·心跳配对', season: '第一季', epNum: 3, duration: '65分钟', date: '2026-07-29', desc: '第一次配对仪式来临，每个人都要做出艰难的选择。有人甜蜜牵手，也有人黯然离场。', img: episodeImages[2] },
  { id: 'ep-4', title: '第四集：新人·惊喜降临', season: '第一季', epNum: 4, duration: '70分钟', date: '2026-08-05', desc: '两位新人突然空降爱情岛，打破了原有的平衡。旧情未了，新欢又来，岛屿风云再起。', img: episodeImages[3] },
];

const homepageArticles = [
  { id: 'article-1', slug: 'season-1-cast-reveal', title: '爱情岛亚洲第一季嘉宾阵容全揭秘', category: '节目资讯', excerpt: '爱情岛亚洲第一季正式公布全部嘉宾阵容，来自中国、日本、韩国、印度、越南等亚洲各国的魅力单身男女即将登岛。', date: '2026-07-10', author: '编辑团队', img: articleImages[0] },
  { id: 'article-2', slug: 'island-location-guide', title: '浪漫岛屿大揭秘：爱情岛拍摄地全攻略', category: '幕后花絮', excerpt: '爱情岛亚洲的拍摄地点选在东南亚一座绝美私人岛屿，碧海蓝天、椰林树影，堪称人间天堂。', date: '2026-07-08', author: '编辑团队', img: articleImages[1] },
  { id: 'article-3', slug: 'reality-dating-psychology', title: '从陌生人到恋人：真人秀恋爱心理学分析', category: '深度观察', excerpt: '为什么真人秀节目中的感情往往发展得比现实生活中更快？心理学家为你深度解析其中的奥秘。', date: '2026-07-05', author: '心理专栏', img: articleImages[2] },
];

export default function Home() {
  const guestsRef = useRef<HTMLDivElement>(null);
  const formUrl = 'https://readdy.ai/api/form/d9q141nnahb7382ov4e0';

  useEffect(() => {
    document.title = '爱情岛亚洲 - 亚洲浪漫恋爱真人秀官方落地页 | 在线观看与报名';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '爱情岛亚洲是专为亚洲单身男女打造的沉浸式恋爱真人秀平台，汇聚来自全亚洲的魅力嘉宾，在浪漫岛屿上展开真实的爱情故事。立即了解节目详情、报名方式及最新播出资讯，开启你的爱情岛亚洲之旅。');
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute('content', '爱情岛亚洲,爱情岛亚洲报名,爱情岛亚洲在线观看,爱情岛亚洲嘉宾,亚洲恋爱真人秀,爱情岛节目,亚洲浪漫综艺');
  }, []);

  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="爱情岛亚洲 - 亚洲浪漫恋爱真人秀官方落地页"
        description="爱情岛亚洲是专为亚洲单身男女打造的沉浸式恋爱真人秀平台，汇聚来自全亚洲的魅力嘉宾，在浪漫岛屿上展开真实的爱情故事。"
        url="https://www.aiqingdao.asia/"
      />
      <FAQPageSchema questions={faqItems} />

      <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Romantic%20tropical%20island%20sunset%20beach%20with%20palm%20trees%20silhouette%2C%20warm%20golden%20light%20reflecting%20on%20calm%20ocean%20water%2C%20luxury%20beach%20villas%20in%20distance%2C%20dreamy%20atmospheric%20mood%2C%20cinematic%20wide%20shot%2C%20soft%20pastel%20sky%20colors&width=1800&height=900&seq=hero-bg-love-island-2026&orientation=landscape"
          alt="爱情岛亚洲浪漫海岛风光"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
            在爱情岛<br className="md:hidden" />遇见你的命中注定
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mb-8 md:mb-10 leading-relaxed">
            亚洲最令人心动的恋爱真人秀 — 汇聚全亚洲魅力单身男女，在浪漫热带岛屿上，展开最真实、最动人的爱情故事
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="#register"
              className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即报名参加
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <Link
              to="/category/all"
              className="inline-flex items-center px-8 py-3.5 rounded-full border-2 border-white/60 text-white text-base font-semibold hover:bg-white/10 hover:border-white transition-all duration-300 whitespace-nowrap"
            >
              了解更多
              <i className="ri-play-circle-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              本季嘉宾
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              来自亚洲各国的魅力单身男女，在这个夏天为爱而来
            </p>
          </div>
          <div ref={guestsRef} className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
            {guests.map((guest) => (
              <div
                key={guest.id}
                className="group relative bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={guest.img}
                    alt={`爱情岛亚洲嘉宾 ${guest.name}`}
                    title={`爱情岛亚洲嘉宾 ${guest.name}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-heading font-semibold text-foreground-950">{guest.name}</h3>
                    <span className="text-xs text-foreground-500">{guest.age}岁</span>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">
                    <i className="ri-map-pin-line mr-1"></i>
                    {guest.from}
                  </p>
                  <p className="text-xs text-foreground-400">{guest.occupation}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              最新剧集
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              第一季正在热播中，每周五晚8点更新
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {episodes.map((ep) => (
              <div
                key={ep.id}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-video overflow-hidden relative">
                  <img
                    src={ep.img}
                    alt={ep.title}
                    title={ep.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
                  <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                    {ep.duration}
                  </div>
                </div>
                <div className="p-4">
                  <span className="text-xs text-accent-500 font-medium">{ep.season}</span>
                  <h3 className="text-sm font-heading font-semibold text-foreground-950 mt-1 mb-2">{ep.title}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2">{ep.desc}</p>
                  <p className="text-xs text-foreground-400 mt-3">{ep.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">最新资讯</h2>
              <p className="text-foreground-600 text-sm">了解爱情岛亚洲的最新动态</p>
            </div>
            <Link
              to="/category/all"
              className="hidden sm:inline-flex items-center text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {homepageArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.img}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                      {article.category}
                    </span>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span>{article.author}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/all"
              className="inline-flex items-center px-6 py-2.5 rounded-full border border-primary-500 text-primary-500 text-sm font-medium hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
            >
              查看全部资讯 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
        </div>
      </section>

      <section id="register" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">加入爱情岛亚洲</h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
            如果你也想在这个夏天遇见爱情，欢迎报名参加爱情岛亚洲。下一个爱情故事的主角，也许就是你。
          </p>
          <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
            <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-6">快速报名</h3>
            {formUrl ? (
              <form
                data-readdy-form=""
                action={formUrl}
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="space-y-4 text-left"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement);
                  if (honeypot && honeypot.value.trim()) {
                    const msgEl = form.querySelector('.form-msg');
                    if (msgEl) msgEl.innerHTML = '<span class="text-primary-500">报名信息已提交，我们将会尽快联系您！</span>';
                    return;
                  }
                  try {
                    const res = await fetch(formUrl, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    });
                    const text = await res.text();
                    let parsed: Record<string, unknown> = {};
                    try { parsed = JSON.parse(text) as Record<string, unknown>; } catch { /* ignore parse error */ }
                    const msgEl = form.querySelector('.form-msg');
                    if (res.ok && parsed?.code === 'OK') {
                      if (msgEl) msgEl.innerHTML = '<span class="text-green-600">报名成功！我们将会在3个工作日内与您联系。</span>';
                      form.reset();
                    } else {
                      const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
                      if (msgEl) msgEl.innerHTML = `<span class="text-red-500">${errMsg}</span>`;
                    }
                  } catch {
                    const msgEl = form.querySelector('.form-msg');
                    if (msgEl) msgEl.innerHTML = '<span class="text-red-500">网络错误，请稍后重试</span>';
                  }
                }}
              >
                <div className="honeypot-wrap">
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <div>
                  <label htmlFor="reg-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input id="reg-name" name="name" type="text" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的姓名" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="reg-age" className="block text-sm font-medium text-foreground-700 mb-1.5">年龄</label>
                    <input id="reg-age" name="age" type="number" required min="18" max="35" className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="18-35" />
                  </div>
                  <div>
                    <label htmlFor="reg-gender" className="block text-sm font-medium text-foreground-700 mb-1.5">性别</label>
                    <select id="reg-gender" name="gender" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors">
                      <option value="">请选择</option>
                      <option value="male">男</option>
                      <option value="female">女</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label htmlFor="reg-from" className="block text-sm font-medium text-foreground-700 mb-1.5">所在国家/地区</label>
                  <input id="reg-from" name="location" type="text" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="如：中国上海" />
                </div>
                <div>
                  <label htmlFor="reg-email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                  <input id="reg-email" name="email" type="email" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的邮箱" />
                </div>
                <div>
                  <label htmlFor="reg-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">手机号码</label>
                  <input id="reg-phone" name="phone" type="tel" className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的手机号码" />
                </div>
                <div>
                  <label htmlFor="reg-intro" className="block text-sm font-medium text-foreground-700 mb-1.5">自我介绍</label>
                  <textarea id="reg-intro" name="introduction" maxLength={500} rows={3} className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none" placeholder="简单介绍一下你自己（500字以内）"></textarea>
                </div>
                <button type="submit" className="w-full py-3 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  提交报名
                </button>
                <div className="form-msg text-sm text-center mt-2"></div>
              </form>
            ) : (
              <p className="text-foreground-500 text-sm">正在加载报名表单...</p>
            )}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
            <p className="text-foreground-600 text-sm">关于爱情岛亚洲，你想知道的都在这里</p>
          </div>
          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <details key={idx} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 group-open:bg-primary-100 group-open:text-primary-500 transition-colors duration-200">
                    <i className="ri-add-line group-open:hidden text-sm"></i>
                    <i className="ri-subtract-line hidden group-open:block text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-20 md:py-24 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Tropical%20beach%20at%20sunset%20with%20soft%20warm%20golden%20light%2C%20calm%20ocean%20waves%2C%20palm%20tree%20silhouettes%2C%20romantic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20dreamy%20pastel%20sky%2C%20luxury%20island%20resort%20vibe&width=1800&height=600&seq=cta-bg-love-island-2026&orientation=landscape"
          alt="爱情岛亚洲CTA背景"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
        <div className="relative z-10 w-full max-w-2xl mx-auto text-center px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            准备好开启你的爱情之旅了吗？
          </h2>
          <p className="text-white/80 text-sm md:text-base mb-8">
            爱情岛亚洲第二季嘉宾招募即将启动，关注我们获取最新报名信息
          </p>
          <a
            href="#register"
            className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即报名 <i className="ri-heart-line ml-2"></i>
          </a>
        </div>
      </section>
    </>
  );
}